import { useMemo } from 'react';

import { useTMContext } from '#src/contexts/tm/index.ts';

import { createTMApolloLink } from './createTMApolloLink.ts';

type Props = {
  path: string;
};

export const useTMLink = ({ path }: Props) => {
  const logOperation = useTMContext()?.logOperation;

  const tmLink = useMemo(() => {
    if (!logOperation) {
      return undefined;
    }

    return createTMApolloLink(logOperation, path);
  }, [logOperation, path]);

  return tmLink;
};
